
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getBatchSetting } from "@/api/api-basic";
import alarmSettingBatchDetail from "./comp/alarmSetting-batch-detail.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "alarmSetting-batch-detail": alarmSettingBatchDetail
  }
})
export default class AlarmSettingBatch extends Vue {
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;

  @Prop({ default: "" }) private tabName!: string;
  private alarmSettingBatchDetail: objAny = {};

  private total = 0;
  private loading = false;
  private formInline: objAny = {
    pageNo: 1,
    pageSize: 10,
    globalOrder: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("alarmsetting.alarmLevel"),
      key: "alarmLevelName",
      width: 180
    },
    {
      title: i18n.t("alarmsetting.faultCode"),
      key: "faultCodeList",
      sortable: true,
      minWidth: 200
    },
    {
      title: i18n.t("operation"),
      key: "resultDes",
      width: 100,
      slot: "action"
    }
  ];
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public pageChange(val: number): void {
    this.formInline.pageNo = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.pageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getBatchSetting();
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  public detailBtn(item: objAny, index: number): void {
    const itemData: objAny = JSON.parse(JSON.stringify(item));
    this.alarmSettingBatchDetail.open(itemData, index);
  }
  public getChild(child: objAny) {
    this.alarmSettingBatchDetail = child;
  }

  mounted() {
    this.getTableList();
  }
}
